import React from 'react'

export default function pdfToWord(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M30.7 6.2 25.4 1c-.3-.3-.7-.5-1.1-.4h-16c-1.1 0-2 .9-2 2v17c.3 0 .7-.1 1-.1 5.1-.1 9.3 4 9.4 9.1 0 .9-.1 1.8-.4 2.7h12.9c1.1 0 2.1-.9 2.1-2v-22c-.1-.4-.3-.8-.6-1.1Z"
          opacity=".1"
        />
        <path
          fill="currentColor"
          d="M7.5 30H4c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Zm0-9C3.4 21 0 24.3 0 28.5S3.3 36 7.5 36s7.5-3.3 7.5-7.5c-.1-4.1-3.4-7.4-7.5-7.5Z"
        />
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M7.5 30H4c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Z"
        />
        <path
          fill="currentColor"
          d="M31.2 5.8 26 .7c-.5-.4-1.1-.7-1.8-.7H8.6c-1.7 0-3 1.3-3.1 2.9v16.8c.3-.1.7-.1 1-.2V3c0-1.1.9-2 2-2h15.7c.4 0 .8.2 1.1.4l5.2 5.1c.3.3.5.7.5 1.1V29c0 1.1-.9 2-2 2H16.3c-.1.3-.2.7-.3 1h13c1.7 0 3-1.3 3-3V7.6c0-.7-.3-1.3-.8-1.8Z"
        />
        <path
          fill="currentColor"
          d="M8.16 14.23h20.92Zm0 3.26h20.97ZM18.47 7.5h10.54Zm0 3.08h10.54Z"
        />
        <path
          fill="currentColor"
          d="M29.13 16.99a.5.5 0 0 1 0 1H8.16a.5.5 0 0 1 0-1h20.97Zm-.05-3.26a.5.5 0 1 1 0 1H8.16a.5.5 0 0 1 0-1h20.92Zm-.07-3.65a.5.5 0 1 1 0 1H18.47a.5.5 0 0 1 0-1h10.54Zm0-3.08a.5.5 0 0 1 0 1H18.47a.5.5 0 0 1 0-1h10.54ZM14.573 3c.388 0 .657.268.657.67v6.016c0 .268-.261.536-.657.536v.008H8.657c-.388 0-.657-.268-.657-.67V3.67c0-.402.261-.67.657-.67h5.916Zm-6.171.803 1.204 5.624h1.13l.878-3.69.884 3.69h1.13l1.2-5.624h-1.107l-.735 3.92-.898-3.92h-.943l-.896 3.918-.74-3.918H8.402Z"
        />
      </svg>
    </div>
  )
}
